
import React, { useEffect } from 'react'
import GoogleMapSearch from '../../../../common/components/google-map-search'
import { InputContainer } from '../../../../common/components/form/form.module'
export default function ParcelBasicInfoComponent({ setDropLocation, setPickupLocation, filterCustomer, handleCustomerSearch, customerListData, dropLocations, pickupLocations, leadValues, handleChange }: any) {

    useEffect(() => {
        const input = document.getElementById("datetime") as HTMLInputElement;

        input.addEventListener("change", function () {
            const minDateTime = new Date(input.min);
            const selectedDateTime = new Date(input.value);
            if (selectedDateTime < minDateTime) {
                alert("Please select a valid time.");
                input.value = input.min; // reset to min
            }
        });

    }, []);

    return (

        <div className="w-full font-bold space-y-4">
            <div className="flex flex-row gap-4">
                <div className="flex-1">

                    <InputContainer
                        label="Existing User"
                        name="IsExistingUser"
                        onValueChange={(event: any) => {
                            handleChange(
                                event,
                                'IsExistingUser'
                            )
                        }}
                        type="checkbox"
                        value={leadValues?.IsExistingUser}
                    />
                </div>
                {
                    leadValues?.IsExistingUser &&
                    <div className="flex-1">
                        <InputContainer
                            className="w-full capitalize font-normal pl-4 pr-7 py-2 border rounded-md bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                            label="Customer Name"
                            labelField="AccountName"
                            placeholder="Type to find a customer..."
                            isLoading={customerListData?.isLoading}
                            list={customerListData?.result?.items}
                            onTypeahead={(event: any) => handleCustomerSearch({ event })}
                            onValueChange={(event: any) => {
                                handleChange(
                                    event,
                                    'CustomerId'
                                )
                            }}
                            type="typeahead"
                            value={leadValues?.CustomerId}
                            valueField="Id"
                        />
                    </div>
                }


            </div>

            <div className="flex flex-row gap-4">
                {!leadValues?.IsExistingUser &&
                    <div className="flex-1">
                        <label className="font-semibold line-clamp-2 mb-2 text-slate-800" htmlFor="grid-password">
                            Email <span className="text-red-500">*</span>
                        </label>
                        <input
                            required
                            type="email"
                            name={"Email"}

                            className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                            onChange={(event) => {
                                handleChange(
                                    event.target.value,
                                    'Email'
                                );

                            }}
                            value={leadValues?.Email} />
                    </div>}
                {!leadValues?.IsExistingUser &&
                    <div className="flex-1">
                        <label className="font-semibold line-clamp-2 mb-2 text-slate-800" htmlFor="grid-password">
                            Name  <span className="text-red-500">*</span>
                        </label>
                        <input
                            required
                            type="text"
                            name={"Name"}
                            className="w-full border font-normal  rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                            onChange={(event) => {
                                handleChange(
                                    event.target.value,
                                    'Name'
                                );
                            }}
                            value={leadValues?.Name} />
                    </div>}
                {!leadValues?.IsExistingUser &&
                    <div className="flex-1">
                        <label className="font-semibold line-clamp-2 mb-2 text-slate-800" htmlFor="grid-password">
                            PhoneNumber <span className="text-red-500">*</span>
                        </label>
                        <input
                            required
                            type="text"
                            maxLength={10}
                            name={"PhoneNumber"}
                            className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                            onChange={(event) => {
                                handleChange(
                                    event.target.value.replace(/\D/g, ''),
                                    'PhoneNumber'
                                );
                            }}
                            value={leadValues?.PhoneNumber} />
                    </div>}
            </div>

            {leadValues?.CustomerId && leadValues?.IsExistingUser &&
                <div className="flex flex-row gap-4">
                    <div className="flex-1">
                        <label className="font-semibold line-clamp-2 mb-2  text-slate-800" htmlFor="grid-password">
                            Email
                        </label>
                        <div className="border font-normal  rounded-md px-4 py-2 text-gray-500 bg-gray-50 cursor-not-allowed">
                            {filterCustomer?.Email}
                        </div>

                    </div>

                    <div className="flex-1">
                        <label className="font-semibold line-clamp-2 mb-2  text-slate-800">Phone Number</label>
                        <div className="border font-normal  rounded-md px-4 py-2 text-gray-500 bg-gray-50 cursor-not-allowedborder font-normal  rounded-md px-4 py-2 text-gray-500 bg-gray-50 cursor-not-allowed">
                            {filterCustomer?.PhoneNumber}
                        </div>
                    </div>
                </div>}

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                <div className="w-full">
                    <label
                        className="font-semibold line-clamp-2 mb-2 text-slate-800"
                    >
                        Weight
                    </label>

                    <input
                        type="text"
                        name="weight"
                        className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onChange={(event: any) => {
                            handleChange(
                                event.target.value,
                                'weight'
                            )
                        }}
                        value={leadValues?.weight}
                    />

                    <span
                        className="block text-xs font-light text-right"
                    >
                        in kg
                    </span>
                </div>
                <div className="w-full">
                    <label
                        className="font-semibold line-clamp-2 mb-2 text-slate-800"
                    >
                        Length
                    </label>

                    <input
                        type="text"
                        name="length"
                        className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onChange={(event: any) => {
                            handleChange(
                                event.target.value,
                                'length'
                            )
                        }}
                        value={leadValues?.length}
                    />

                    <span
                        className="block text-xs font-light text-right"
                    >
                        in mm
                    </span>
                </div>
                <div className="w-full">
                    <label
                        className="font-semibold line-clamp-2 mb-2 text-slate-800"
                    >
                        Breadth
                    </label>

                    <input
                        type="text"
                        name='breadth'
                        className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onChange={(event: any) => {
                            handleChange(
                                event.target.value,
                                'breadth'
                            )
                        }}
                        value={leadValues?.breadth}
                    />

                    <span
                        className="block text-xs font-light text-right"
                    >
                        in mm
                    </span>
                </div>
                <div className="w-full">
                    <label
                        className="font-semibold line-clamp-2 mb-2 text-slate-800"
                    >
                        Height
                    </label>

                    <input
                        type="text"
                        name="height"
                        className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onChange={(event: any) => {
                            handleChange(
                                event.target.value,
                                'height'
                            )
                        }}
                        value={leadValues?.height}
                    />

                    <span
                        className="block  text-xs font-light text-right"
                    >
                        in mm
                    </span>
                </div>
            </div>

            {/* Address Fields */}

            <div className="w-full">
                <label className="font-semibold line-clamp-2 mb-2 text-slate-800" htmlFor="from">
                    From <span className="text-red-500">*</span>
                </label>

                <GoogleMapSearch
                    className="w-full font-normal  ps-8  pe-10 py-2 border rounded-md bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                    setLocation={setPickupLocation}
                    location={pickupLocations}
                    placeholder="From Address"
                    required
                />


            </div>


            <div className="w-full">
                <label className="font-semibold line-clamp-2 mb-2 text-slate-800" htmlFor="to">
                    To <span className="text-red-500">*</span>
                </label>

                <GoogleMapSearch
                    className="w-full font-normal  ps-8  pe-10 py-2 border rounded-md bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                    setLocation={setDropLocation}
                    location={dropLocations}
                    placeholder="To Address"
                    required
                />

            </div>

            {/* Schedule Date */}

            <div className="w-1/3">
                <label className="font-semibold line-clamp-2 mb-2 text-slate-800" htmlFor="date">
                    Schedule Date & Time<span className="text-red-500">*</span>
                </label>
                <input
                    id="datetime"
                    type="datetime-local"
                    name="date"
                    min={
                        new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
                            .toISOString()
                            .slice(0, 16)
                    }
                    className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                    onChange={(event) => handleChange(event.target.value, "date")}
                    onBlur={(event: any) => {
                        if (!event.target.value) alert(`Schedule Date is required`);
                    }}
                    onClick={(event) => {
                        const input = event.target as HTMLInputElement; // Type cast to HTMLInputElement
                        input.showPicker(); // Now you can call showPicker() safely
                    }}
                    value={leadValues?.date || ""}
                    required
                />
            </div>


            <div className="w-full ">
                <label className="font-semibold line-clamp-2 mb-2 text-slate-800">Additonal Information</label>

                <textarea
                    name={"additionainfo"}
                    className="w-full h-20 font-normal border rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                    onChange={(event: any) => {
                        handleChange(
                            event.target.value,
                            'Description'
                        )
                    }}
                    value={leadValues?.Description}
                />
            </div>




        </div>



    )
}